import { Inject, Injectable } from "@angular/core";
import { IRoundHistoryRepository } from './interfaces';
import { catchError, distinctUntilChanged, Observable, of } from "rxjs";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";
import { addHistoryRounds, clearHistoryRounds } from "./store/round-history.actions";
import { ERoundState, IRound } from "../core/round/interfaces";
import { GAME_NAME_TOKEN } from "@karma-games/angular-devkit/src/lib/interfaces";
import { HttpService } from "@karma-games/angular-devkit/src/lib/services/http";
import { map, take } from "rxjs/operators";

@Injectable()
export class RoundHistoryRepository implements IRoundHistoryRepository {
    constructor(private store: Store,
                @Inject(GAME_NAME_TOKEN) private gameName: string,
                private http: HttpService) {
        this.fetchInitialRoundHistory().pipe(take(1))
            .subscribe((dataArr: number[]) => {
                this.store.dispatch(addHistoryRounds({ roundCoefficients: dataArr }));
            });

        this.store.subscribeRound().pipe(distinctUntilChanged((prevRound: IRound | undefined, currRound: IRound | undefined) => {
            return prevRound?.state === currRound?.state
        })).subscribe(this.handleRoundUpdate);
    }

    get(): Observable<number[]> {
        return this.store.subscribeRoundHistoryList();
    }

    private handleRoundUpdate = (round: IRound | undefined): void => {
        if (round && round.state === ERoundState.Ended) {
            this.store.dispatch(addHistoryRounds({ roundCoefficients: [round.multiplier] }));
        }
    }

    clear(): void {
        this.store.dispatch(clearHistoryRounds());
    }

    private fetchInitialRoundHistory(): Observable<number[]> {
        return this.http.get(`games/${this.gameName}/history`).pipe(map(response => response.body.data),
            catchError((err) => {
                console.error(err);
                return of([]);
            }));
    }
}
